import { cn as e } from "../cn.js";
import t from "react";
import * as n from "lucide-react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import a from "dompurify";
// src/design/icon/index.tsx
function o(e) {
	return e ? typeof window < "u" && window.document ? a.sanitize(e, {
		ALLOWED_TAGS: [
			"svg",
			"path",
			"rect",
			"circle",
			"ellipse",
			"line",
			"polyline",
			"polygon",
			"g",
			"defs",
			"use",
			"symbol",
			"title",
			"desc"
		],
		ALLOWED_ATTR: [
			"viewBox",
			"width",
			"height",
			"fill",
			"stroke",
			"stroke-width",
			"stroke-linecap",
			"stroke-linejoin",
			"d",
			"x",
			"y",
			"cx",
			"cy",
			"r",
			"rx",
			"ry",
			"transform",
			"href",
			"xlink:href",
			"class",
			"id",
			"style"
		],
		FORBID_TAGS: ["script", "foreignObject"],
		FORBID_ATTR: [
			"onload",
			"onerror",
			"onclick",
			"onmouseover",
			"onfocus",
			"onblur",
			"onkeydown",
			"onkeyup",
			"javascript:",
			"data:",
			"vbscript:"
		],
		ADD_ATTR: ["viewBox", "preserveAspectRatio"]
	}) : e.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "").replace(/\s*on\w+\s*=\s*(['"])[^'"]*\1/gi, "").replace(/javascript:/gi, "").replace(/data:/gi, "") : "";
}
var s = {
	xs: "w-3 h-3",
	sm: "w-4 h-4",
	md: "w-5 h-5",
	lg: "w-6 h-6",
	xl: "w-8 h-8",
	"2xl": "w-10 h-10"
}, c = {
	inherit: "text-current",
	default: "text-foreground",
	muted: "text-muted-foreground",
	primary: "text-primary",
	secondary: "text-muted-foreground",
	success: "text-success",
	warning: "text-warning",
	danger: "text-destructive",
	info: "text-info",
	brand: "text-primary",
	accent: "text-primary"
}, l = {
	default: "",
	ghost: "opacity-60 hover:opacity-100 transition-opacity duration-normal",
	outline: "stroke-2",
	subtle: "opacity-75"
};
function u(e) {
	return e.type !== "custom" && "name" in e;
}
function d(e) {
	return e.type === "custom";
}
function f(t) {
	let { size: a = "md", color: f = "inherit", variant: p = "default", className: m, onClick: h, loading: g = !1, decorative: _ = !1, style: v, strokeWidth: y = 2 } = t, b = e(s[a], c[f], l[p], {
		"cursor-pointer": h,
		"animate-spin": g,
		"pointer-events-none": g
	}, m), x = {
		"aria-hidden": _ ? !0 : void 0,
		"aria-label": t["aria-label"],
		role: h ? "button" : void 0,
		tabIndex: h ? 0 : void 0,
		strokeWidth: y
	}, S = () => {
		g || h?.();
	}, C = (e) => {
		g || h && (e.key === "Enter" || e.key === " ") && (e.preventDefault(), h());
	};
	if (d(t)) {
		let { svg: e, alt: n, viewBox: a = "0 0 24 24" } = t;
		if (typeof e == "string") {
			let t = o(e);
			return /* @__PURE__ */ r("div", {
				className: b,
				onClick: S,
				onKeyDown: C,
				style: v,
				...x,
				dangerouslySetInnerHTML: { __html: t }
			});
		}
		return /* @__PURE__ */ i("svg", {
			className: b,
			viewBox: a,
			fill: "none",
			xmlns: "http://www.w3.org/2000/svg",
			onClick: S,
			onKeyDown: C,
			style: v,
			...x,
			children: [n && /* @__PURE__ */ r("title", { children: n }), e]
		});
	}
	if (u(t)) {
		let { name: i } = t, a = n[i];
		if (!a) {
			console.warn(`Icon "${i}" not found in Lucide React. Please check the icon name.`);
			let t = n.HelpCircle;
			return /* @__PURE__ */ r(t, {
				className: e(b, "text-destructive-text"),
				onClick: S,
				onKeyDown: C,
				style: v,
				...x
			});
		}
		return /* @__PURE__ */ r(a, {
			className: b,
			onClick: S,
			onKeyDown: C,
			style: v,
			...x
		});
	}
	return null;
}
f.Lucide = function(e) {
	return /* @__PURE__ */ r(f, {
		...e,
		type: "lucide"
	});
}, f.Custom = function(e) {
	return /* @__PURE__ */ r(f, {
		...e,
		type: "custom"
	});
};
function p(e) {
	return t.useMemo(() => n[e] || null, [e]);
}
function m() {
	return Object.keys(n).filter((e) => /^[A-Z]/.test(e) && !e.endsWith("Icon") && !e.startsWith("Lucide"));
}
function h({ icon: t, onClick: n, disabled: i = !1, buttonVariant: a = "default", size: o = "md", className: s, ...c }) {
	return /* @__PURE__ */ r("button", {
		type: "button",
		onClick: n,
		disabled: i,
		className: e("inline-flex items-center justify-center rounded-lg transition-all duration-normal focus-ring", {
			default: "hover:bg-accent",
			primary: "bg-primary hover:bg-primary/90 text-primary-foreground",
			secondary: "bg-secondary hover:bg-secondary/80",
			ghost: "hover:bg-accent hover:text-foreground",
			outline: "border border-border hover:bg-accent"
		}[a], {
			xs: "p-1",
			sm: "p-1.5",
			md: "p-2",
			lg: "p-2.5",
			xl: "p-3",
			"2xl": "p-4"
		}[o], {
			"opacity-50 cursor-not-allowed": i,
			"transform active:scale-95": !i
		}, s),
		"aria-label": c["aria-label"],
		children: /* @__PURE__ */ r(f, {
			name: t,
			size: o,
			color: a === "primary" ? "default" : c.color,
			decorative: !0
		})
	});
}
function g({ icon: t, text: n, orientation: a = "horizontal", textSize: o = "sm", gap: s = "sm", onClick: c, className: l, ...u }) {
	let d = {
		xs: "gap-1",
		sm: "gap-2",
		md: "gap-3",
		lg: "gap-4"
	}, p = {
		xs: "text-xs",
		sm: "text-sm",
		md: "text-base",
		lg: "text-md"
	}, m = e("inline-flex items-center", a === "vertical" ? "flex-col" : "flex-row", d[s], { "cursor-pointer hover:opacity-80 transition-opacity duration-normal": c }, l);
	return /* @__PURE__ */ i("div", {
		className: m,
		onClick: c,
		role: c ? "button" : void 0,
		tabIndex: c ? 0 : void 0,
		children: [/* @__PURE__ */ r(f, {
			name: t,
			decorative: !0,
			...u
		}), /* @__PURE__ */ r("span", {
			className: e(p[o], "font-medium"),
			children: n
		})]
	});
}
function _({ text: e, icon: t = "spinner", size: n = "md", className: i, ...a }) {
	let o = {
		spinner: "Loader2",
		dots: "MoreHorizontal",
		pulse: "Circle"
	}[t];
	return e ? /* @__PURE__ */ r(g, {
		icon: o,
		text: e,
		size: n,
		className: i,
		loading: !0,
		decorative: !0,
		...a
	}) : /* @__PURE__ */ r(f, {
		name: o,
		size: n,
		className: i,
		loading: !0,
		decorative: !0,
		...a
	});
}
export { f as Icon, g as IconWithText, h as IconsButton, _ as LoadingIcon, m as getAllLucideIconNames, p as useIcon };

//# sourceMappingURL=index.js.map